
import { defineComponent, ref, useContext } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'CatalogFastDelivery',
  props: {
    slug: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const {
      app: { $content },
    } = useContext()

    const fastDeliverySetId = ref<string | null>(null)

    $content('products', 'fastDelivery')
      .fetch()
      .then((data: { sets: string[] }) => {
        const fastDeliverySets = data.sets.filter(
          s => s === props.slug.toUpperCase()
        )

        if (fastDeliverySets.length > 0) {
          fastDeliverySetId.value = fastDeliverySets[0]
        }

        fastDeliverySetId.value = null

      })

    return {
      fastDeliverySetId,
    }
  },
})
